<template>
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="商店名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.storeName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select
            v-model="queryParam.status"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="成功" value="1"></el-option>
            <el-option label="提现中" value="2"></el-option>
            <el-option label="失败" value="3"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">创建时间</span>
          <el-date-picker
            size="mini"
            v-model="createDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #status="slotData">
        <p v-if="slotData.data.row.status == 1">成功</p>
        <p v-if="slotData.data.row.status == 2">提现中</p>
        <p v-if="slotData.data.row.status == 3">失败</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button v-if="slotData.data.row.status == 2" type="success" size="mini" @click="audit('0', slotData.data.row.$index, slotData.data.row)">通过</el-button>
        <el-button v-if="slotData.data.row.status == 2" type="danger" size="mini" @click="audit('-1', slotData.data.row.$index, slotData.data.row)">拒绝</el-button>
      </template>
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { filterObj } from '@/utils/util';
import { postAction } from "@/api/manage";
import { busiUserwithdrawaudit } from "@/api/management";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/busiUser/withdraw/list",
      },
      queryParam: {},
      createDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      columns: [
        {
          field: "storeName",
          fixed: "left",
          label: "商店名称",
        },
        {
          field: "wlBusiUserName",
          label: "商户名称",
        },
        {
          field: "phone",
          label: "商户手机号",
        },
        {
          field: "amount",
          label: "金额",
        },
        {
          label: "状态",
          columnType: "slot",
          slotName: "status",
        },
        {
          field: "createTime",
          label: "提现时间",
        },
        {
          field: "bankName",
          label: "提现银行",
        },
        {
          field: "bankSubName",
          label: "提现支行",
        },
        {
          field: "bankAccount",
          label: "户名",
        },
        {
          field: "bankCardNo",
          label: "提现卡号",
        },
        {
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      deviceList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    audit(num, index, row) {
      let name = num == "0" ? "通过" : "拒绝";
      this.$confirm(`正在执行${name}操作, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        busiUserwithdrawaudit({ id: row.id, status: num }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.loadData(1);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    dateChange(date) {
      if (date) {
        this.queryParam.start = date[0] + " 00:00:00";
        this.queryParam.end = date[1] + " 23:59:59";
      } else {
        this.queryParam.start = "";
        this.queryParam.end = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.createDate = "";
      this.searchQuery();
    },
    // loadData(arg) {
    //   if (!this.url.list) {
    //     this.$message.error('请设置url.list属性!');
    //     return;
    //   }
    //   if (arg === 1) {
    //     this.ipagination.current = 1;
    //   }
    //   var params = this.getQueryParams();
    //   this.loading = true;
    //     postAction(this.url.list, params).then((res) => {
    //       if (res.msg) {
    //         this.$message.warning(res.msg);
    //         return;
    //       }
    //       this.dataSource = res.data.records
    //       if (res.data.total) {
    //         this.ipagination.total = res.data.total;
    //       } else {
    //         this.ipagination.total = 0;
    //       }
    //       this.loading = false;
    //     });
    // },
    // getQueryParams() {
    //   var param = Object.assign(this.queryParam, this.isorter, this.filters);
    //   param.page = this.ipagination.current;
    //   param.pageSize = this.ipagination.pageSize;
    //   param.childFlag = 0;
    //   param.filter = 0;
    //   return filterObj(param);
    // },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
